import * as R from 'ramda';
import {
  pure,
  withState,
  withHandlers,
  withPropsOnChange } from 'react-recompose';
// helpers/constants
import * as G from '../../../../helpers';
import * as GC from '../../../../constants';
// feature edit-report
import { defaultSortFields } from './settings';
import {
  SORT_FIELD_DND_ID,
  omitSortFieldDndIds,
  createSortFieldDndId,
  ensureSortFieldDndId,
  reorderFieldsOnDrugEnd,
  getAvailableForReportSort,
  ensureSortFieldListDndIds,
  mapFieldsWithSequenceFromIndex,
} from '../../helpers';
//////////////////////////////////////////////////

export const withReportSortList = R.compose(
  withState('reportSortList', 'setReportSortList', []),
  withState('availableForSort', 'setAvailableForSort', []),
  withPropsOnChange(['sortFields'], (props) => {
    const {
      sortFields,
      reportSortList,
      setReportSortList,
      setAvailableForSort,
    } = props;

    if (G.isNilOrEmpty(sortFields)) return;

    if (G.deepEquals(sortFields, omitSortFieldDndIds(reportSortList))) return;

    setReportSortList(ensureSortFieldListDndIds(sortFields));

    setAvailableForSort(getAvailableForReportSort(props, sortFields));
  }),
  withHandlers({
    handleAddSortField: (props) => () => {
      const {
        reportSortList,
        setReportSortList,
        setAvailableForSort,
      } = props;

      const newField = ensureSortFieldDndId(R.assoc(
        'sequence',
        R.inc(R.length(reportSortList)),
        defaultSortFields,
      ));
      const fieldsUpdated = R.append(newField, reportSortList);

      setReportSortList(fieldsUpdated);

      setAvailableForSort(getAvailableForReportSort(props, fieldsUpdated));
    },
    handleRemoveSortField: (props) => (filterIndex) => {
      const {
        reportSortList,
        setReportSortList,
        setAvailableForSort,
      } = props;

      const fieldsUpdated = mapFieldsWithSequenceFromIndex(R.dissocPath([filterIndex], reportSortList));

      setReportSortList(fieldsUpdated);

      setAvailableForSort(getAvailableForReportSort(props, fieldsUpdated));
    },
    handleSelectSortName: (props) => (values) => {
      const {
        reportSortList,
        setReportSortList,
        setAvailableForSort,
      } = props;

      const { fieldIndex, data: { type, value, referenceFieldName } } = values;

      const sortFieldDndId = R.path([fieldIndex, SORT_FIELD_DND_ID], reportSortList);

      let newField = {
        ...defaultSortFields,
        name: value,
        reference: R.equals(type, 'reference'),
        [SORT_FIELD_DND_ID]: R.or(sortFieldDndId, createSortFieldDndId()),
      };

      if (G.isNotNil(referenceFieldName)) {
        newField = R.assoc(GC.FIELD_REFERENCE_FIELD_NAME, referenceFieldName, newField);
      }
      const fieldsUpdated = R.assocPath([fieldIndex], newField, reportSortList);

      setReportSortList(fieldsUpdated);

      setAvailableForSort(getAvailableForReportSort(props, fieldsUpdated));
    },
    handleChangeFieldOrder: (props) => ({ order, fieldIndex }) => {
      const {
        reportSortList,
        setReportSortList,
        setAvailableForSort,
      } = props;

      const fieldsUpdated = R.assocPath([fieldIndex, 'order'], order, reportSortList);

      setReportSortList(fieldsUpdated);

      setAvailableForSort(getAvailableForReportSort(props, fieldsUpdated));
    },
    handleSortDragEnd: (props) => (result) => {
      const {
        reportSortList,
        setReportSortList,
        setAvailableForSort,
      } = props;

      const reorderedFields = reorderFieldsOnDrugEnd(reportSortList, result);

      setReportSortList(reorderedFields);

      setAvailableForSort(getAvailableForReportSort(props, reorderedFields));
    },
  }),
  pure,
);
